// Pure-constants module. Lives in its own file (and NOT inside index.tsx,
// which is marked 'use client') so server-side modules — specifically the
// page-component/*.server.ts data fetchers under App Router — can import
// the enum value without going through a React Client Manifest lookup.
//
// The React Server Components bundler can't safely resolve individual enum
// members of a 'use client' module: it tries to bind `HeaderNavCurLink.X` as
// a client reference and fails at SSR time. Server-safe modules like this
// avoid the trap.

export enum HeaderNavCurLink {
  SNOW_REPORTS = 'snow_reports',
  TRIP_PLANNING = 'trip_planning',
  MAGAZINE = 'magazine',
  MAIN = 'index',
  SKIGPT = 'skigpt',
}
